import React from 'react';
import Slick from "react-slick";
import {Grid2 as Grid, Paper, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";

const _epCarouselButtonList = ({carousel}) => {

    const navigate = useNavigate();

    function getCarouselItem(item, index) {
        switch (item?.Type) {
            case "CAROUSEL_ITEM_SPORT_CAT":
                return gymCategoryItem(item, index);
        }
    }

    function gymCategoryItem(item, index) {
        return (
            <Grid sx={{placeItems: "center", alignItems: "center", alignContent: "center", mt: 1}} alignItems={"center"}
                  alignContent={"center"} textAlign={"center"} direction={"column"} container key={index}
                  onClick={() => navigate(item?.Data)}>
                <Paper sx={{m: "auto", width: "100px", borderRadius: 8, p: 2}} elevation={8}>
                    <img width={64} src={item?.multimedia?.Url}/>
                </Paper>
                <Typography sx={{fontWeight: "600", textAlign: "center", mt: 1}} variant={"body2"}>{item?.Title}</Typography>
            </Grid>
        );
    }

    return (
        <>
            {carousel?.Items&&<Slick {...JSON.parse(carousel?.Data)}>
                {[...carousel?.Items, ...carousel?.Items, ...carousel?.Items]?.map((item, index) => (getCarouselItem(item, index)))}
            </Slick>}
        </>
    );
};

export default _epCarouselButtonList;
